<template>
	<div class="p-3">
		<h1>{{ getMessage_('SWCC000131') }}</h1>
		<h4>{{ getMessage_('SWCC000132') }}</h4>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
export default {
	computed: {
		...rootComputed
	},

	methods: {
		...rootMethods
	}
};
</script>

<style></style>
